export const getTwoDecimalPlaces = (price) => {
  const absoluteNumber = Math.abs(price); // Ensure positive value
  const numberString = absoluteNumber.toString();
  const firstTwoDigits = numberString.substring(0, 2);
  return parseInt(firstTwoDigits);
};
